import { IconCallMe } from '@f_components/icons/IconCallMe';
import { IconExit } from '@f_components/icons/IconExit';
import { IconQWEP } from '@f_components/icons/IconQwep';
import { AuthContext } from '@f_context/Auth_context';
import { Library } from '@f_components/manual/Library';
import { ThemeContext } from '@f_context/Theme_context';
import { useWindowSize } from '@f_hooks/index';
import stls from '@f_styles/components/header/Header.module.sass';
import { Button, Typography } from '@mui/material';
import Divider from '@mui/material/Divider';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { CallMeModal } from './CallMeModal';
import { ReferralButton } from './ReferralButton';
import { ReferralModal } from './ReferralModal';

type HeaderProps = {
    showLogout?: boolean;
};

export function Header({ showLogout = false }: HeaderProps) {
    const { t } = useTranslation();
    const { colors, currentTheme } = useContext(ThemeContext);
    const { logout } = useContext(AuthContext);
    const [mobile, setMobile] = useState(false);
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [openReferral, setOpenReferral] = useState(false);
    const { width } = useWindowSize();

    useEffect(() => {
        setMobile(width < 1200);
    }, [width]);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpenReferral = () => {
        setOpenReferral(true);
    };

    const handleCloseReferral = () => {
        setOpenReferral(false);
    };

    const logoutHandler = async () => {
        await logout();
    };

    return (
        <header style={{ background: colors.betaHeader }} className={stls.container}>
            <Divider orientation="vertical" flexItem />
            <button
                style={{ display: 'flex', marginLeft: '55px' }}
                type="button"
                onClick={() => !showLogout && navigate('/app-qwep')}>
                {currentTheme === 'vinpin' ? (
                    <div>{/* <IconVinPin width={'304px'} height={'41px'} /> */}</div>
                ) : (
                    <IconQWEP width={'130px'} height={'45px'} />
                )}
            </button>
            {!showLogout && <ReferralButton onClick={handleOpenReferral} />}
            <div className={showLogout ? stls.migratedActions : stls.buttonCallMe}>
                {!showLogout && window.location.pathname == '/company' && (
                    <div style={{ margin: '0 15px' }}>
                        <Library />
                    </div>
                )}
                {mobile ? (
                    <button
                        style={{ border: `1.5px solid ${colors.alpha}` }}
                        className={stls.mobileButton}
                        onClick={handleOpen}>
                        <IconCallMe />
                    </button>
                ) : (
                    <Button
                        className={stls.siteButton}
                        onClick={handleOpen}
                        variant="outlined"
                        sx={{
                            '&.MuiButton-outlined': { border: `1px solid rgba(33, 142, 225, 0.5)` },
                            '&.MuiButton-outlined:hover': { border: `1px solid #3F8DC8` },
                        }}>
                        {t('common.header.callMe')}
                    </Button>
                )}
                {showLogout && (
                    <button type="button" className={stls.logoutButton} onClick={logoutHandler}>
                        <Typography variant="body2" style={{ color: colors.alpha }}>
                            {t('settings.logout')}
                        </Typography>
                        <IconExit />
                    </button>
                )}
            </div>
            <CallMeModal handleClose={handleClose} open={open} />
            {!showLogout && <ReferralModal handleClose={handleCloseReferral} open={openReferral} />}
        </header>
    );
}
